import { clientApp } from './index';

export const postConnect = (data: { email: string; password: string }) =>
  clientApp.post('/ui/nexudus/oauth/connect', data);

export const deleteWebhook = (id: number) => clientApp.delete(`/ui/nexudus/settings/webhook/${id}`);

export const getImportInvoice = (invoiceNumber: string) =>
  clientApp.get(`/ui/nexudus/invoice/import/${encodeURIComponent(invoiceNumber)}`);
